import React from "react";
import {
  TextInput,
  SimpleForm,
  required,
  SelectInput,
  PasswordInput,
  ArrayInput,
  SimpleFormIterator,
  EditProps,
} from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import RetypePasswordInput from "components/RetypePasswordInput";
import { Grid, Typography } from "@material-ui/core";
import { relationshipList, salutationList } from "./conts";
import CustomEditToolbar from "components/CustomEditToolbar";
import {
  mobilePhoneNoValidation,
  postalCodeValidation,
  vaNumberValidation,
} from "utils/validation";
import CustomAddressAutoCompleteInput from "./components/CustomAddressAutoCompleteInput";
import NameInput from "../../components/NameInput";
import EmailInput from "../../components/EmailInput";
import EditWrapper from "../../components/EditWrapper";

const ParentEdit = (props: EditProps) => {
  const { id } = props;

  const breadcrumb = [
    { link: "/parents", title: "Parents" },
    { link: `/parents/${id}`, title: id },
  ];

  const transform = async (data: any) => {
    if (data.user.password === "" || data.user.passwordConfirmation === "") {
      delete data.user.password;
      delete data.user.passwordConfirmation;
    }

    data.alternateContacts = data.alternateContacts
      ? data.alternateContacts.map((alternateContact: IAlternateContact) => ({
          ...alternateContact,
          id: alternateContact.id == null ? 0 : alternateContact.id,
        }))
      : [];

    data.billingEmails = data.billingEmails.map(
      (billingEmail: IBillingEmail) => ({
        id: billingEmail.id == null ? 0 : billingEmail.id,
        email: billingEmail.email,
      })
    );

    return data;
  };

  return (
    <>
      <EditWrapper
        breadcrumb={breadcrumb}
        isFullName
        transform={transform}
        {...props}
      >
        <SimpleForm toolbar={<CustomEditToolbar isShowDelete={false} />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Personal Details</Typography>
            </Grid>

            <Grid item xs={1}>
              <SelectInput source="salutation" choices={salutationList} />
            </Grid>
            <Grid item xs={11}></Grid>

            <Grid item xs={4}>
              <NameInput label="First Name" source="firstName" />
            </Grid>

            <Grid item xs={4}>
              <NameInput label="Last Name" source="lastName" />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <EmailInput label="Email" source="user.email" />
            </Grid>
            <Grid item xs={4}>
              <TextInput
                label="Mobile No."
                source="mobile"
                validate={mobilePhoneNoValidation}
              />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <PasswordInput label="Password" source="user.password" />
            </Grid>
            <Grid item xs={4}>
              <RetypePasswordInput />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <TextInput
                label="VA Number"
                source="vaNumber"
                validate={vaNumberValidation}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Billing Info</Typography>
            </Grid>

            <Grid item xs={2}>
              <TextInput
                label="Billing Name"
                source="billingAddress.name"
                validate={required()}
              />
            </Grid>
            <Grid item xs={10}></Grid>

            <Grid item xs={4}>
              <CustomAddressAutoCompleteInput
                label="Postal Code"
                source="billingAddress.postalCode"
                referenceSource="locationData"
                validate={postalCodeValidation}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={2}>
              <TextInput label="Unit No." source="billingAddress.unit" />
            </Grid>
            <Grid item xs={2}>
              <TextInput
                label="Block No."
                source="billingAddress.blockNumber"
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput
                label="Building Name"
                source="billingAddress.building"
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput
                label="Address"
                source="billingAddress.address"
                validate={required()}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Billing Emails</Typography>
            </Grid>

            <Grid item xs={7}>
              <ArrayInput source="billingEmails" validate={required()}>
                <SimpleFormIterator>
                  <EmailInput label="Email" source="email" />
                </SimpleFormIterator>
              </ArrayInput>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Alternate Contacts</Typography>
            </Grid>

            <Grid item xs={7}>
              <ArrayInput source="alternateContacts">
                <SimpleFormIterator>
                  <TextInput
                    label="Contact Name"
                    source="name"
                    validate={required()}
                  />
                  <TextInput
                    label="Contact Mobile No."
                    source="contactNumber"
                    validate={mobilePhoneNoValidation}
                  />
                  <EmailInput label="Email" source="email" isNullable />
                  <SelectInput
                    label="Relationship"
                    source="relationship"
                    choices={relationshipList}
                    validate={required()}
                  />
                </SimpleFormIterator>
              </ArrayInput>
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default ParentEdit;
